import { getSearchParams, parseBoolean } from '@amzn/vinyl-util'

export const debug = parseBoolean(getSearchParams().get('debug'))
